<template>
    <div class="focused-well-page" :dir="direction">
        <app-header />
        <lab-sub-header />
        <demo-disclaimer v-if="showDemoDisclaimer" />

        <focused-well-center-content
            v-if="focusedWell"
            :class="{ 'has-demo-disclaimer': showDemoDisclaimer }"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AppHeader from '../components/Header'
import LabSubHeader from '../components/LabSubHeader'
import DemoDisclaimer from '../components/common/DemoDisclaimer.vue'
import FocusedWellCenterContent from '../components/FocusedWellCenterContent'

export default {
    name: 'FocusedWell',
    components: {
        AppHeader,
        LabSubHeader,
        DemoDisclaimer,
        FocusedWellCenterContent
    },
    computed: {
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell,
            selectedTreatment: state => state.timelapse.selectedTreatment,
            triggerWellReFetch: state => state.timelapse.triggerWellReFetch
        }),
        ...mapGetters({
            direction: 'locale/direction',
            showDemoDisclaimer: 'common/showDemoDisclaimer'
        })
    },
    watch: {
        $route(to, from) {
            if (to.params.well_id !== from.params.well_id) {
                this.loadWellData()
            }
        },
        triggerWellReFetch(shouldFetch) {
            if (shouldFetch) this.loadWellData(true)
        }
    },
    mounted() {
        this.loadWellData()
    },
    methods: {
        async loadWellData(forceFullReload = false) {
            await this.$store.dispatch('timelapse/setWellData', {
                forceFullReload,
                route: this.$route
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.focused-well-page {
    position: relative;
    height: 100%;

    @media screen and #{$new-break2close} {
        .app-header,
        .lab-sub-header {
            display: none;
        }

        .focused-well-center-content {
            height: 100%;

            &.has-demo-disclaimer {
                height: calc(100% - #{$sub-header-height});
            }
        }
    }

    @media screen and #{$new-break3open} {
        .focused-well-center-content {
            height: calc(100% - #{$header-height} - #{$sub-header-height});

            &.has-demo-disclaimer {
                height: calc(100% - #{$header-height} - 2 * #{$sub-header-height});
            }
        }
    }
}
</style>
